"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_USERS_FAILED = exports.GET_USERS_SUCCEEDED = exports.GET_USERS_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/userMgmt/service"));
exports.GET_USERS_REQUESTED = "GET_USERS_REQUESTED";
exports.GET_USERS_SUCCEEDED = "GET_USERS_SUCCEEDED";
exports.GET_USERS_FAILED = "GET_USERS_FAILED";
function default_1(users, updatedSince = null) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const request = {
            users,
            updatedSince
        };
        const requestAction = {
            type: exports.GET_USERS_REQUESTED,
            payload: request
        };
        dispatch(requestAction);
        const result = yield service_1.default.getUsers(request);
        let outcomeEvent;
        if (result.kind === "success") {
            outcomeEvent = {
                type: exports.GET_USERS_SUCCEEDED,
                payload: {
                    request,
                    result: {
                        users: result.users,
                        timestamp: result.timestamp
                    }
                }
            };
        }
        else {
            outcomeEvent = {
                type: exports.GET_USERS_FAILED,
                payload: request,
                httpError: result.kind === "httpError" ? result : undefined
            };
        }
        dispatch(outcomeEvent);
    });
}
exports.default = default_1;
